import React from 'react';
import {Modal} from 'react-native';

import BuildProblemModal from '../BuildProblemModal/BuildProblemModal';
import UpdateModal from '../UpdateModal/UpdateModal';
import CommunicationModal from '../CommunicationModal/CommunicationModal';
import {useCommunicationModalStore} from '../../store/CommunicationModalStore';

interface AppModalHostProps {
  showBuildProblem: boolean;
  showUpdate: boolean;
}

/**
 * Host único para todos os modais bloqueantes do app.
 *
 * No iOS o React Native só consegue apresentar UM <Modal> nativo por vez;
 * apresentar/descartar dois ao mesmo tempo faz o iOS descartar um deles em
 * silêncio (era o que causava "só aparece uma ou outra" na entrada do app).
 *
 * Mantendo um único <Modal> e apenas trocando o CONTEÚDO por prioridade,
 * não há ciclo present/dismiss concorrente: só há uma apresentação (quando
 * o primeiro surge) e um descarte (quando não há mais nada). Sem setTimeout.
 *
 * Prioridade: problema de build > atualização > comunicação.
 */
const AppModalHost = ({showBuildProblem, showUpdate}: AppModalHostProps) => {
  const activeCommunicationModal = useCommunicationModalStore(
    state => state.activeModal,
  );

  const kind: 'build' | 'update' | 'communication' | null = showBuildProblem
    ? 'build'
    : showUpdate
    ? 'update'
    : activeCommunicationModal
    ? 'communication'
    : null;

  return (
    <Modal
      animationType="fade"
      transparent
      visible={kind !== null}
      onRequestClose={() => {}}>
      {kind === 'build' && <BuildProblemModal />}
      {kind === 'update' && <UpdateModal />}
      {kind === 'communication' && <CommunicationModal />}
    </Modal>
  );
};

export default AppModalHost;
